import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject, Observable, Subject, bufferToggle, catchError, map, of, tap, throwError } from "rxjs";
import { BACKEND_URLS, BackendUrls } from "app/app.config";
import { WmsMapType, WmsMapTypeOptions } from '@googlemaps/ogc';
import { DOCUMENT } from "@angular/common";
import { environment } from '../../environments/environment';

interface GeoJsonMultiLineString {
    type: "MultiLineString";
    coordinates: [number, number][][];
}

const WMS_REGIONE = "https://geoservizi.regione.liguria.it/geoserver/M2248/wms?"
const TILE_SIZE = 256;
const EARTH_RADIUS_IN_METERS = 6378137;
const CIRCUMFERENCE = 2 * Math.PI * EARTH_RADIUS_IN_METERS;




@Injectable({
    providedIn: 'root'
})
export class GMapService {

    constructor(
        @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
        @Inject(DOCUMENT) private _document: any,
        private _httpClient: HttpClient,

    ) { }

    private _lines: BehaviorSubject<google.maps.Polyline[] | null> = new BehaviorSubject([]);
    private _position: BehaviorSubject<google.maps.LatLng | null> = new BehaviorSubject(null);
    private _geoJson: BehaviorSubject<GeoJsonMultiLineString | null> = new BehaviorSubject(null);

    get geoJson$(): Observable<GeoJsonMultiLineString> {
        return this._geoJson.asObservable();
    }

    get geometry$(): Observable<google.maps.Polyline[]> {
        return this._lines.asObservable();
    }

    get position$(): Observable<google.maps.LatLng>{
        return this._position.asObservable();
    }

    private _map: google.maps.Map;
    pano: any;
    _editMode: boolean = false;
    mapMarker: google.maps.marker.AdvancedMarkerElement;
    mousePosition: google.maps.LatLngLiteral;
    private _mapOverlays: any = {};
    layerStatus: any = {}
    mapDiv: any;
    delDiv: any



    private _mapCenter:google.maps.LatLngLiteral;
    private _mapZoom: number;
    private _mapId:string
    private selectedLine:google.maps.Polyline = null;
    private deleteButton: HTMLButtonElement;

    private lineColor = "#3b61dd";
    private selectedColor = "#e20000";

    private linesX:any[];

    mapTypeIds = [];
    baseMapId: string = "OSM";


    BaseMaps = [
        { id: 'roadmap', title: 'Google strade' },
        { id: 'satellite', title: 'Google sat' },
        //{id:'hybrid', title:'Google hibrid'},
        //{id:'terrain', title:'Google terreno'},
        { id: 'OSM', title: 'OpenStreetMap' },
        { id: 'ORTOFOTO_2019', title: 'Ortofoto 2019' },
        { id: 'WIMS', title: 'Esri World' },
    ]

    wmsLayers = environment.wmsLayers;


    setOverlays() {
        let index: number;
        const activ = [];
        this._map.overlayMapTypes.forEach((ov) => activ.push(ov.name))

        for (let id in this.layerStatus) {
            index = activ.indexOf(id);
            if (this.layerStatus[id] === false && index > -1) { //considero solo quelli attivi
                this._map.overlayMapTypes.removeAt(index);
            }
            if (this.layerStatus[id] && index == -1) { //Aggingo solo se non c'è
                //this._map.overlayMapTypes.insertAt(Math.min(0, this._map.overlayMapTypes.getLength()),this._mapOverlays[id]);
                this._map.overlayMapTypes.push(this._mapOverlays[id])//per ora metto in cima
            }

        }
    }


    public setPosition(position: google.maps.LatLngLiteral){

        console.log(position)
        this.mapMarker.map = this._map
        this._map.setCenter(position);
        this.mapMarker.position = position;
        this._map.setZoom(20);

    }


    public async initMap(mapDiv: HTMLElement, options: google.maps.MapOptions, geometry:any=null): Promise<google.maps.Map> {
        const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        const DrawingManager = await google.maps.importLibrary("drawing")
        const geom = await google.maps.importLibrary("geometry") as google.maps.MarkerLibrary;

        for (var type in google.maps.MapTypeId) {
            this.mapTypeIds.push(google.maps.MapTypeId[type]);
        }

        const mapOptions = {
            mapId: this._mapId,
            mapTypeControl: false,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            },
            scaleControl: true,
            streetViewControl: true,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            fullscreenControl: true,
            controlSize: 32,
            center:this._mapCenter,
            zoom:this._mapZoom
        }

        const map: google.maps.Map = new Map(mapDiv, { ...mapOptions, ...options });
        this._map = map;

        const setPolyEvents = (poly: google.maps.Polyline) => {
            poly.addListener('click',()=>{
                this.clearLines();
                poly.setOptions({clickable:true, editable:true,draggable:true,strokeColor:this.selectedColor});
                this.selectedLine = poly;
                this.deleteButton.hidden=false;
            })
        }

        //aggiungo le basi cablate qui sul servizio (per ora) con OSM di default in partenza
        this.addOSM();
        this.addWIMS();
        this.addOrtofoto2019();

        //setto la base di default
        this.setBaseMap(this.baseMapId);

        //creo l'elenco degli overlay che arrivano dalla configurazione
        this.wmsLayers.map((ov) => {
            this._mapOverlays[ov.id] = this.getOverlay(ov.id, ov.url, ov.layers);
            this.layerStatus[ov.id] = ov.active;
        });
        this.setOverlays()




/*         if (geometry){
            if (typeof geometry=='string'){
                this.EwktToPolylines(geometry)
            }

            else {
                this.GeoJsonToPolylines(geometry)
            }
        }

        this.deleteButton = document.createElement("button");
        this.deleteButton.type="button";
        this.deleteButton.classList.add("delete-overlay-button");
        this.deleteButton.hidden = this.selectedLine==null;
        this.deleteButton.addEventListener('click',()=>{

            let index=-1;
            const lines = this._lines.value
            lines.forEach((p,ix)=>{
                if (this.selectedLine==p){
                    console.log("trovata",p)
                    index = ix;
                    this.selectedLine.setMap(null)
                    this.selectedLine=null
                    this.deleteButton.hidden=true
                }
            })
            if (index!=-1){
                lines.splice(index,1);
                this._lines.next(lines)
            }



        })
        map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.deleteButton);

        const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.POLYLINE,
                ],
            },




        });



        drawingManager.setMap(map);
        drawingManager.addListener('polylinecomplete',(poly:google.maps.Polyline)=>{

            if (poly.getPath().getLength()<2){
                return
            }


            this.clearLines();
            this.selectedLine = poly;
            poly.setOptions({clickable:true, editable:true,draggable:true,strokeColor:this.selectedColor});

            setPolyEvents(poly);

            const lines = this._lines.value
            lines.push(poly)
            this._lines.next(lines)
            this._geoJson.next(this.PolylinesToGeoJson(lines))

            this.deleteButton.hidden = false;
            drawingManager.setDrawingMode(null);

        }) */

        //this.deleteButton.hidden=true;
        const parser = new DOMParser();
        const pinSvgString = '<svg width="64" height="64" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 4.42 4.26 8.99 6.24 10.98a1 1 0 0 0 1.52 0C14.74 17.99 19 13.42 19 9c0-3.87-3.13-7-7-7z" fill="#4285F4" stroke="#1A73E8" stroke-width="1"/><circle cx="12" cy="9" r="4" fill="#FFFFFF"/><path d="M10 9c0-1.1.9-2 2-2s2 .9 2 2v1h-4V9z" fill="#FFD700"/><path d="M12 7c-1.66 0-3 1.34-3 3v1h6v-1c0-1.66-1.34-3-3-3z" fill="#FFA000"/><path d="M9 10h6v1H9z" fill="#FFA000"/><rect x="11" y="4.5" width="2" height="4" fill="#D32F2F"/><circle cx="12" cy="10.5" r="0.5" fill="#D32F2F"/></svg>'

        const pinSvg = parser.parseFromString(pinSvgString, 'image/svg+xml').documentElement;

        this.mapMarker = new AdvancedMarkerElement({
            title: 'Uluru',
            content: pinSvg,
            gmpDraggable: true
        })
        this.mapMarker.addListener('dragend', (event:google.maps.MapMouseEvent)=>this._position.next(event.latLng))


        return map

    }


    getGeometry(id: string): Observable<google.maps.Polyline[] | null> {
      return this._httpClient
          .get<any>(`${this.backendUrls.backendApiUrl}/istanze/${id}/geometry`)
          .pipe(
              map(response=>response["data"]),
              catchError((error) => {
                console.error("Errore :", error);
                return throwError(error); // Gestione dell'errore
            })
          )
    }



    clearLines = ()=>{
        this.selectedLine = null
        this._lines.value.forEach((p)=>{
            p.setOptions({editable:false,draggable:false,strokeColor:this.lineColor})
        })
    }

    addStreetView(panoDiv: HTMLElement, map: google.maps.Map) {
        const pos = map.getCenter();
        const pano_position = google.maps.geometry.spherical.computeOffset(pos, 5, 5);
        const heading = google.maps.geometry.spherical.computeHeading(pano_position, pos);
        const panorama = new google.maps.StreetViewPanorama(
            panoDiv,
            {
                position: pano_position,
                pov: {
                    heading: heading,
                    pitch: -35,
                },
                addressControl: false,
                linksControl: false,
                panControl: false,
                enableCloseButton: false,
                fullscreenControl: false,
                zoomControl: false
            }
        );
        new google.maps.Marker({
            map: panorama,
            position: pos,
            animation: google.maps.Animation.DROP,
        });
        this.pano = panorama
        map.setStreetView(panorama);

        const attributionControl = this._document.createElement('div');
        attributionControl.style.padding = '10px';
        attributionControl.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
        attributionControl.style.border = '1px solid #grey';
        attributionControl.innerHTML = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
        map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(attributionControl);



    }

    //Tiles openstreetmap
    addOSM() {
        this._map.mapTypes.set("OSM", new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) => {
                return "https://tile.openstreetmap.org/" + zoom + "/" + coord.x + "/" + coord.y + ".png";
            },
            tileSize: new google.maps.Size(256, 256),
            name: "OpenStreetMap",
            maxZoom: 18
        }));
        this.mapTypeIds.push("OSM");
    }

    //Tiles Esri
    addWIMS() {
        this._map.mapTypes.set("WIMS", new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) => {
                return "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/" + zoom + "/" + coord.y + "/" + coord.x;
            },
            tileSize: new google.maps.Size(TILE_SIZE, TILE_SIZE),
            name: "World_Imagery (MapServer)",
            maxZoom: 18
        }));
        this.mapTypeIds.push("WIMS");
    }

    //Base WMS Regione Liguria
    addOrtofoto2019() {
        const overlay = this.getOverlay('ORTOFOTO_2019', WMS_REGIONE, 'L8256')
        this._map.mapTypes.set("ORTOFOTO_2019", overlay);
        this.mapTypeIds.push("ORTOFOTO_2019");
    }

    getOverlay(name: string, url: string, layers: string): google.maps.ImageMapType {
        return new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) => this._getWMSTileUrl(coord, zoom, url, layers),
            tileSize: new google.maps.Size(TILE_SIZE, TILE_SIZE),
            name: name,
            maxZoom: 18,
            opacity: 0.6

        })
    }

    addWmsLayer(url: string, layers: string) {
        const overlay = new google.maps.ImageMapType({
            getTileUrl: (coord, zoom) => this._getWMSTileUrl(coord, zoom, url, layers),
            tileSize: new google.maps.Size(TILE_SIZE, TILE_SIZE),
            maxZoom: 18,
            opacity: 0.6
        })
    }

    setBaseMap(base: string) {
        this._map.setMapTypeId(base)
    }

    loadGoogleMaps(libraries:string): Observable<string> {

        if (!this._document.getElementById('g-map-lib')) {

            return this._httpClient.get<string>(`${this.backendUrls.backendApiUrl}/mapsettings`)
                .pipe(
                    map(response => response["data"]),
                    map(data => {
                        this._mapCenter=data["center"];
                        this._mapZoom=data["zoom"];
                        this._mapId=data["mapid"];
                        return data["key"];
                    }),
                    tap((mapkey) => {
                        const script = this._document.createElement('script');
                        script.type = 'text/javascript';
                        script.text = '(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({\
                                        v: "weekly",\
                                        libraries: "' + libraries + '",\
                                        key: "' + mapkey + '"});'
                        script.id = 'g-map-lib';
                        this._document.head.appendChild(script);
                    }),
                    // Error here means the requested contact is not available
                    catchError((error) => {
                        // Log the error
                        console.error(error);
                        // Throw an error
                        return of('')
                    }),
                )
        }
        return of('')
    }


    private GeoJsonToPolylines(
        geoJson: GeoJsonMultiLineString
    ): google.maps.Polyline[] | null {

        if (geoJson.type !== "MultiLineString") {
            console.error("GeoJSON geometry must be of type 'MultiLineString'");
            return null;
        }

        //const polylines: google.maps.Polyline[] = [];

        const map = this._map;

        const lines = this._lines.value


        // Itera su ciascuna linea del MultiLineString
        geoJson.coordinates.forEach((lineCoords) => {
            // Converti le coordinate di ciascuna linea in oggetti LatLng
            const path = lineCoords.map(
                (coord) => new google.maps.LatLng(coord[1], coord[0])
            );

            // Crea una polilinea editabile per ogni linea nel MultiLineString
            const polyline = new google.maps.Polyline({
                path,
                editable: false,     // Abilita la modifica
                draggable: false,     // Abilita lo spostamento della linea
                map,                 // Aggiungi la linea alla mappa
                strokeColor: this.lineColor,
                strokeOpacity: 1.0,
                strokeWeight: 4,
            });

            // Aggiungi la polilinea all'array di polilinee
            lines.push(polyline);

            // Aggiungi eventuali listener agli eventi di modifica della polilinea
            google.maps.event.addListener(polyline.getPath(), "set_at", () => {
                console.log("Path modified", polyline.getPath().getArray());
            });
            google.maps.event.addListener(polyline.getPath(), "insert_at", () => {
                console.log("Point added", polyline.getPath().getArray());
            });
            google.maps.event.addListener(polyline.getPath(), "remove_at", () => {
                console.log("Point removed", polyline.getPath().getArray());
            });

            polyline.addListener('click',()=>{
                this.clearLines();
                polyline.setOptions({clickable:true, editable:true,draggable:true,strokeColor:this.selectedColor});
                this.selectedLine = polyline;
                this.deleteButton.hidden=false;
            })



        });

        this._lines.next(lines)
        this._geoJson.next(this.PolylinesToGeoJson(lines))

    }


    private EwktToPolylines(ewkt:string){
        const coordinates = ewkt
        .replace(/SRID=\d+;MULTILINESTRING\(\(/, '')
        .replace(/\)\)$/, '')
        .split('),(').map(line => line.split(',').map(coord => {
            const [lng, lat] = coord.trim().split(' ').map(Number);
            return { lat: lat, lng: lng };

    }));

    const lines = coordinates.map(points=>{
        const map=this._map
        const poly = new google.maps.Polyline({
            map:map,
            path: points,
            strokeColor: this.lineColor,
            strokeWeight: 4,
            strokeOpacity: 1,
            zIndex: 999
        })
        poly.addListener('click',()=>{
            this.clearLines();
            poly.setOptions({clickable:true, editable:true,draggable:true,strokeColor:this.selectedColor});
            this.selectedLine = poly;
            this.deleteButton.hidden=false;
        })
        return poly

    })
    this._lines.next(lines)
    }


    private PolylinesToGeoJson(polylines: google.maps.Polyline[]): GeoJsonMultiLineString {
        const coordinates: [number, number][][] = polylines.map((polyline) => {
            // Ottieni il percorso della polilinea e converti in coordinate GeoJSON [lon, lat]
            return polyline.getPath().getArray().map((latLng) => [
                latLng.lng(), // GeoJSON usa [lon, lat]
                latLng.lat(),
            ]);
        });

        // Crea l'oggetto GeoJSON MultiLineString
        const geoJson: GeoJsonMultiLineString =  {
            type: "MultiLineString",
            coordinates: coordinates,
        }
        return geoJson;
    }



    //potrebbe non servire vedi sotto....
    private _pixelToLatLng(map: google.maps.Map, offsetx: number, offsety: number) {
        var latlng = map.getCenter();
        var scale = Math.pow(2, map.getZoom());
        var nw = new google.maps.LatLng(
            map.getBounds().getNorthEast().lat(),
            map.getBounds().getSouthWest().lng()
        );

        var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
        var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

        var worldCoordinateNewCenter = new google.maps.Point(
            worldCoordinateCenter.x - pixelOffset.x,
            worldCoordinateCenter.y + pixelOffset.y
        );

        var latLngPosition = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

        return latLngPosition.toJSON();
    }


    //per usare i WMS come base chiamati in 3857
    private _getWMSTileUrl(coord: google.maps.Point, zoom: number, baseUrl: string, layers: string) {

        const getMercatorCoord = (x: number, y: number, resolution: number) => {
            return {
                x: x * TILE_SIZE * resolution - CIRCUMFERENCE / 2.0,
                y: y * TILE_SIZE * resolution - CIRCUMFERENCE / 2.0
            };
        };
        let x = coord.x;
        let y = coord.y;

        y = Math.pow(2, zoom) - y - 1; // Translate Y value
        const resolution = (CIRCUMFERENCE / TILE_SIZE) / Math.pow(2, zoom); // meters per pixel
        const swPoint = getMercatorCoord(x, y, resolution);
        const nePoint = getMercatorCoord(x + 1, y + 1, resolution);
        var bbox = swPoint.x + "," + swPoint.y + "," + nePoint.x + "," + nePoint.y;
        return `${baseUrl}SERVICE=WMS&VERSION=1.3.0&EXCEPTIONS=XML&REQUEST=GetMap&LAYERS=${layers}&FORMAT=image%2Fpng&TRANSPARENT=TRUE&CRS=EPSG:3857&STYLES=&BBOX=${bbox}&width=${TILE_SIZE}&height=${TILE_SIZE}`;

    };


    setMapPosition(position: google.maps.LatLngLiteral) {
        this.mapMarker.position = position
        this._map.setCenter(position)
    }





}
